import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from 'react';

type Error = {
  message: string;
  title: string;
};

type ErrorContextProps = {
  error: Error | null;
  setError: Dispatch<SetStateAction<Error | null>>;
};

export const ErrorContext = createContext<ErrorContextProps>({
  error: null,
  setError: () => {},
});

export function ErrorProvider({ children }: { children: ReactNode }) {
  const [error, setError] = useState<Error | null>(null);

  return (
    <ErrorContext.Provider value={{ error, setError }}>
      {children}
    </ErrorContext.Provider>
  );
}

export const useError = () => useContext(ErrorContext);
